export enum ApiQueryKeys {
  MEMBER_ROLES = 'member_roles',
}
